module.exports = __webpack_public_path__ + "static/img/nini_wu.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wmm/nini_wu.jpg
// module id = fp/2
// module chunks = 0